import HTTP from "../../http";

const PRODUCTS_ENDPOINT = "/products";
const SAMPLE_ENDPOINT = "/sample";

export async function getSample() {
  return await HTTP.get(PRODUCTS_ENDPOINT + SAMPLE_ENDPOINT);
}
